
import { selectOrdersByIds } from '@/entities/orders'
import { scenariosSelectors } from '@/entities/schedules'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { getUnassignedRowFromOrder } from '../libs/getUnassignedRowFromOrder'
import { upsertOnePlanningUnassignedTable } from '../slices/planningUnassignedTablesSlice'

type UpdatePlanningUnassignedTablePayload = {
  scenarioId: EntityId
}

export const updatePlanningUnassignedTableState = createAsyncThunk<void, UpdatePlanningUnassignedTablePayload, { state: RootState }>(
  'planningUnassignedTable/update',
  async ({ scenarioId }, { getState, dispatch }) => {
    const state = getState()
    const scenario = scenariosSelectors.selectById(state, scenarioId)
    const scenarioOrderIds = scenario?.unassignedOrders
    const orders = selectOrdersByIds(state, scenarioOrderIds)

    if (!orders) {
      throw new Error('Redux thunk error [planningUnassignedTable/update]: orders not found')
    }

    const rows = orders.map((order) => getUnassignedRowFromOrder(order, scenarioId))

    dispatch(upsertOnePlanningUnassignedTable({
      scenarioId: scenarioId,
      scenarioName: scenario?.name || '',
      isLoading: false,
      rows,
    }))
  },
)
